const API_URL = process.env.VUE_APP_API_URL || ''

export function resolveFileUrl(url) {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  return API_URL + url
}

export function resolveFileThumb(file) {
  if (!file) return ''
  return resolveFileUrl(file.urlThumb || file.url)
}
